import React from 'react'
import _ from 'lodash'

// 业务页面的根。之上为 RootApp、用户App、路由，之下为 业务页面
export function withRoot(pageConfig) {
  return function wrap(Component) {
    return class extends React.PureComponent {
      static displayName = `fwPageWithRoot(${
        Component.displayName || Component.name || 'Component'
      })`

      static async getInitialProps(ctx) {
        const lifecycleProps = await ctx.__AL_EX_internalScope.callGlobalLifecycle(
          ctx,
          {
            isModule: false,
            isApp: false,
            isPage: true,
            isInstance: false,
          }
        )
        if (
          Object.keys(lifecycleProps).length > 0 &&
          !('pageProps' in lifecycleProps)
        ) {
          throw new Error('页面级的 lifecycle，不能返回 pageProps 以外的内容')
        }

        let pageInitialProps
        if (Component.getInitialProps) {
          pageInitialProps = await Component.getInitialProps(ctx)
        }
        return {
          ...lifecycleProps.pageProps,
          ...pageInitialProps,
        }
      }

      constructor(props) {
        super(props)
        const lifecycleProps = props.ctx.__AL_EX_internalScope.callGlobalLifecycle(
          props.ctx,
          {
            isModule: false,
            isApp: false,
            isPage: true,
            isInstance: true,
          }
        )
        if (
          Object.keys(lifecycleProps).length > 0 &&
          !('pageProps' in lifecycleProps)
        ) {
          throw new Error('页面级的 lifecycle，不能返回 pageProps 以外的内容')
        }

        this.state = { lifecycleProps }
      }

      render() {
        const pageProps = {
          ...this.state.lifecycleProps.pageProps,
          ...this.props,
        }

        // 移除业务无需感知的 prop
        delete pageProps.__AL_EX_PAGE_IDENTITY_Ia4TZzV7F1x12Jp3

        // 最终渲染前，再次更新 pageProps，以便 render Document 时，能正确的捕捉到最新的 pageProps
        const transferPageProps = {}
        Object.entries(pageProps).forEach(([k, v]) => {
          if (v) {
            if (typeof v === 'object') {
              if (_.isPlainObject(v) && !['ctx', 'url'].includes(k)) {
                transferPageProps[k] = v
              }
            } else {
              transferPageProps[k] = v
            }
          }
        })
        Object.assign(
          this.props.ctx.__AL_EX_internalScope.extraDocPageProps,
          transferPageProps
        )

        // 原在此实现 isExport && !shouldPrerenderOnExportTarget 时渲染为空节点
        // 已调整到 withRootApp 实现，此处全部放行
        return <Component {...pageProps} />
      }
    }
  }
}
